// AUTO-GENERATED by aveq-app/scripts/install-card-plugins.js.
// Sourced from helper-side cards/ directories. Do not edit.

import _climate_time_traveler from './plugins/climate.time_traveler';
import _directory_results from './plugins/directory.results';
import _gtfs_station_info from './plugins/gtfs.station_info';
import _gtfs_train_time from './plugins/gtfs.train_time';
import _pico_wifi_status from './plugins/pico.wifi_status';
import _presto_control from './plugins/presto.control';
import _sensor_aggregation from './plugins/sensor.aggregation';
import _sensor_verdict from './plugins/sensor.verdict';
import _tobin_dish from './plugins/tobin.dish';
import _tobin_menu from './plugins/tobin.menu';
import _tobin_plan from './plugins/tobin.plan';
import _tobin_restaurant_actions from './plugins/tobin.restaurant_actions';
import _tobin_restaurant_info from './plugins/tobin.restaurant_info';
import _weather_correction from './plugins/weather.correction';

const PLUGINS = {
  'climate.time_traveler': _climate_time_traveler,
  'directory.results': _directory_results,
  'gtfs.station_info': _gtfs_station_info,
  'gtfs.train_time': _gtfs_train_time,
  'pico.wifi_status': _pico_wifi_status,
  'presto.control': _presto_control,
  'sensor.aggregation': _sensor_aggregation,
  'sensor.verdict': _sensor_verdict,
  'tobin.dish': _tobin_dish,
  'tobin.menu': _tobin_menu,
  'tobin.plan': _tobin_plan,
  'tobin.restaurant_actions': _tobin_restaurant_actions,
  'tobin.restaurant_info': _tobin_restaurant_info,
  'weather.correction': _weather_correction,
};

export default PLUGINS;
